// extracted by mini-css-extract-plugin
export var button = "_lr-2";
export var card = "_lr-0";
export var closeButtonContainer = "_lr-3";
export var iconContainer = "_lr-1";